// extracted by mini-css-extract-plugin
module.exports = {"wallpaper":"wallpaper--bRata"};